angular.module('clientDashboardApp')
  .filter('camelCaseToHuman', () =>
    (input) => input
      .charAt(0).toUpperCase() + input.substr(1).replace(/[A-Z]/g, ' $&'))
  .filter('capitalize', () =>
    (input) => input.charAt(0).toUpperCase() + input.substr(1).toLowerCase());
